import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../../../shared-components/TextField/TextField';

const LOCALE_PREFIX = 'GB/components/Address/Address';

export class Street2 extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;

        return (
            <div>
                <Field
                    id="street2"
                    name="street2"
                    autoComplete="disabled"
                    required={false}
                    component={TextField}
                    label={intl.formatMessage({id: `${LOCALE_PREFIX}.addressLine2`})}
                />
            </div>
        );
    }
}

export default injectIntl(Street2);
